import { Box, Button, Container } from "@mui/material";
import { NavLink } from "react-router";

function Nav() {
  return (
    <Box id="nav" sx={{ backgroundColor: "rgb(255, 255, 255);" }}>
      <Container id="nav-container" sx={{ paddingTop: 2, paddingBottom: 2 }}>
        <Button LinkComponent={NavLink} to="/">Start</Button>
        <Button LinkComponent={NavLink} to="/map">Hitta dina lokala pärlor</Button>
        <Button LinkComponent={NavLink} to="/ga-med">Bli en del av lokala pärlor</Button>
        <Button LinkComponent={NavLink} to="/vara-tjanster">Våra tjänster</Button>
        <Button LinkComponent={NavLink} to="/kontakta-oss">Kontakta oss</Button>
        <Button LinkComponent={NavLink} to="/om-oss">Om oss</Button>
      </Container>
    </Box>
  );
}

export default Nav;